import React from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader, Table } from "reactstrap"
import dayjs from "dayjs"

const InfoModal = props => {
  const { isOpen, toggle, data } = props

  if (!data) return null

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      tabIndex="-1"
      toggle={toggle}
    >
      <ModalHeader toggle={toggle} className="bg-light">
        <i className="mdi mdi-information text-info me-2 font-size-20 align-middle"></i>
        Edit Details
      </ModalHeader>
      <ModalBody>
        <div className="table-responsive">
          <Table className="table table-bordered mb-0">
            <tbody>
              <tr>
                <th className="bg-light text-muted w-50">Last Edited Date & Time</th>
                <td className="text-primary font-weight-semibold">
                  {data?.lastEditedAt ? dayjs(data.lastEditedAt).format("DD/MM/YYYY hh:mm:ss A") : "-"}
                </td>
              </tr>
              <tr>
                <th className="bg-light text-muted">Edited From (PC IP)</th>
                <td>
                  <span className="badge badge-soft-info font-size-12 px-2 py-1 text-info">
                    {data?.lastEditedIp || "-"}
                  </span>
                </td>
              </tr>
              <tr>
                <th className="bg-light text-muted">What was Edited</th>
                <td>
                  {data?.editedFields && data.editedFields.length > 0 ? (
                    <div className="d-flex flex-wrap gap-1">
                      {data.editedFields.map((field, idx) => (
                        <span key={idx} className="badge badge-soft-warning font-size-12 px-2 py-1 text-warning">
                          {field}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span className="badge badge-soft-secondary font-size-12 px-2 py-1 text-secondary">
                      Details
                    </span>
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  )
}

InfoModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  data: PropTypes.object,
}

export default InfoModal
